// @ts-nocheck
import { setMemberInfo } from "@store/Framework/Services/Pages/UserSetup/MailChimpEmailService";
import { MailChimpMemberResponseModel } from "@store/Framework/Types/ApiModels";
import { MailChimpMemberInterestsModel } from "@store/Framework/Types/ApiModels";
import { ApiHandler, createHandlerChainRunner } from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = ApiHandler<MailChimpMemberInterestsModel, MailChimpMemberResponseModel>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        ...props.parameter,
    };
};

export const SetMemberInfo: HandlerType = async props => {
    props.apiResult = await setMemberInfo(props.apiParameter);
};

export const DispatchCompleteSetMemberInfo: HandlerType = props => {
    const { dispatch, apiResult } = props;
    dispatch({
        type: "Store/Pages/UserSetup/SetMemberInfo",
        response: apiResult,
    });
};

export const chain = [PopulateApiParameter, SetMemberInfo, DispatchCompleteSetMemberInfo];

const setMailChimpMemberInfo = createHandlerChainRunner(chain, "SetMailChimpMemberInfo");
export default setMailChimpMemberInfo;
